<template>
	<!-- 侧边栏工具 -->
	<div class="nexsidetls">
		<div class="nexsidetools">
			<ul>
				<li @mouseover="selectStyle" @mouseout="outStyle" class="nexsd_kf">
					<div class="nexstout">
						<img v-show="active==false" src="http://www.mools.net/lims/web/OfficialWebsite/exam/kf.png">
						<span  :class="{'active':active}" >客服电话</span>
					</div>
					<div  v-show="active" class="nexsthds">
						<div class="nexsthdstops">
							<img src="http://www.mools.net/lims/web/OfficialWebsite/exam/qq.png">
							<a href="http://wpa.qq.com/msgrd?v=1&uin=2966035427&site=qq&menu=yes" target="_blank">点击联系客服</a>
							<p>在线时间：8:30-18:00</p>
						</div>
						<div class="nexsthdcbtms">
							<h5>客服电话</h5>
							<p>15930129890</p>
							<h4>电子邮件</h4>
							<span>moolsnet@126.com</span>
						</div>
					</div>
				</li>
		<!-- 		<li  @mouseover="selectStyle2" @mouseout="outStyle2">
					<div class="nexstout">
						<a onclick="showWindow('nav', this.href, 'get', 0)" href="forum.php?mod=misc&amp;action=nav">
							<img v-show="active2==false"  src="http://www.mools.net/lims/web/OfficialWebsite/exam/ft.png">
							<span :class="{'active2':active2}">快速发帖</span>
						</a>
					</div>
				</li> -->
				<li @mouseover="selectStyle3" @mouseout="outStyle3">
					<div class="nexstout">
						<a href="mailto:moolsnet@126.com" target="_blank">
							<img v-show="active3==false" src="http://www.mools.net/lims/web/OfficialWebsite/exam/qa.png">
							<span :class="{'active3':active3}">问题反馈</span>
						</a>
					</div>
				</li>
				<li  @mouseover="selectStyle4" @mouseout="outStyle4" class="nexsd_app">
					<div class="nexstout nexstout_app">
						<img v-show="active4==false"  src="http://www.mools.net/lims/web/OfficialWebsite/exam/app.png">
						<span :class="{'active4':active4}">APP下载</span>
					</div>
					<div v-show="active4"   class="nexsthds nexsthds_app nexAPPuiBox">
						<div class="nexstappsd nexAPPui">
							<i></i>
							<div class="nexAPPinters">
								<p>MoosNet APP</p>
								<p>三维互动式虚拟实验</p>
								<img src="https://www.mools.net/lims/web/OfficialWebsite/img/应用宝.png">
							</div>
							<em></em>
						</div>
					</div>
				</li>
				<li  @mouseover="selectStyle5" @mouseout="outStyle5" class="nexsd_wx">
					<div class="nexstout nexstout_wx">
						<img v-show="active5==false" src="http://www.mools.net/lims/web/OfficialWebsite/exam/wx.png">
						<span :class="{'active5':active5}">官方微信</span>
					</div>
					<div v-show="active5"  class="nexsthds nexsthds_weixin">
						<div class="nexstwxsd">
							<p>扫描二维码</p>
							<p>关注moolsnet微信公众号</p>
							<img src="http://www.mools.net/HTML/assets/img/qrcode.jpg">
						</div>
					</div>
				</li>
				<!--返回顶部-->
				<li id="scrolltop" style="left: 922px; right: 0px; visibility: hidden;">
					<div class="nexstout nexstout_up">
						<a id="nexGoToTop">
							<img src="http://www.mools.net/lims/web/OfficialWebsite/exam/up.png">
							<span>返回顶部</span>
						</a>
					</div>

				</li>
			</ul>
		</div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				active: false,
				active2: false,
				active3: false,
				active4: false,
				active5: false,
			}
		},
		methods: {
			selectStyle() {

				this.active = true;
			},
			outStyle() {
				this.active = false;
			},
			selectStyle2() {

				this.active2 = true;
			},
			outStyle2() {
				this.active2 = false;
			},
				selectStyle3() {

				this.active3 = true;
			},
			outStyle3() {
				this.active3 = false;
			},
				selectStyle4() {

				this.active4 = true;
			},
			outStyle4() {
				this.active4 = false;
			},
				selectStyle5() {

				this.active5 = true;
			},
			outStyle5() {
				this.active5 = false;
			}
		}
	}
</script>

<style>
@import "../../../static/css/cebianlan.css";
</style>



// WEBPACK FOOTER //
// src/views/cebianlan/cebianlan.vue